module.exports = __webpack_public_path__ + "static/the-great-convergence-142aba3104b7705ab11eb654ea2f2f12.jpg";